/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle, _circle2, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _circle3, _path113, _path114, _path115, _circle4, _path116, _path117, _path118, _circle5, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _rect, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _circle6, _circle7, _path270, _path271, _circle8, _circle9, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _circle0, _circle1, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _circle10, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _circle11, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388;
const didWarnAboutDeprecation = {};
const IotPlatform = /*#__PURE__*/React.forwardRef(function IotPlatform({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,21H11V11H21Zm-8-2h6V13H13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31,13H29A10.0117,10.0117,0,0,0,19,3V1A12.0131,12.0131,0,0,1,31,13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IotPlatform.propTypes = iconPropTypes;
}
const Ip = /*#__PURE__*/React.forwardRef(function Ip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,23h-2v-14h6c1.103,0,2,.897,2,2v5c0,1.103-.897,2-2,2h-4v5Zm0-7h4v-5.0015h-4v5.0015Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M7 11L10 11 10 21 7 21 7 23 15 23 15 21 12 21 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ip.propTypes = iconPropTypes;
}
const Iso = /*#__PURE__*/React.forwardRef(function Iso({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,28,23ZM24,11V21h4V11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Iso.propTypes = iconPropTypes;
}
const IsoFilled = /*#__PURE__*/React.forwardRef(function IsoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H24V19H21z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IsoFilled.propTypes = iconPropTypes;
}
const IsoOutline = /*#__PURE__*/React.forwardRef(function IsoOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2v6A2,2,0,0,1,24,21Zm-3-8v6h3V13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15,21H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H12v2h3a2,2,0,0,1,2,2v2A2,2,0,0,1,15,21Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H8V21H6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IsoOutline.propTypes = iconPropTypes;
}
const ItemDefinition = /*#__PURE__*/React.forwardRef(function ItemDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h24c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2ZM28,28H4V4h24v24ZM10,22v-1.8232h1.582v-8.3574h-1.582v-1.8223h5.4512v1.8223h-1.5991v8.3574h1.5991v1.8232h-5.4512ZM18.0906,19.7129v-4.9487h-1.3242v-1.7539h.688c.6538,0,.8599-.3096.8599-.9287v-1.5171h1.9775v2.4458h1.8403v1.7539h-1.8403v5.4819h1.7026v1.7539h-1.582c-1.5132,0-2.3218-.8252-2.3218-2.2871Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ItemDefinition.propTypes = iconPropTypes;
}
const ItemUsage = /*#__PURE__*/React.forwardRef(function ItemUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30h-10c-5,0-9-4-9-9v-10C2,6,6,2,11,2h10c5,0,9,4,9,9v10c0,5-4,9-9,9ZM11,4c-3.9,0-7,3.1-7,7v10c0,3.9,3.1,7,7,7h10c3.9,0,7-3.1,7-7v-10c0-3.9-3.1-7-7-7h-10ZM10,22v-1.8232h1.582v-8.3574h-1.582v-1.8223h5.4512v1.8223h-1.5991v8.3574h1.5991v1.8232h-5.4512ZM18.0906,19.7129v-4.9487h-1.3242v-1.7539h.688c.6538,0,.8599-.3096.8599-.9287v-1.5171h1.9775v2.4458h1.8403v1.7539h-1.8403v5.4819h1.7026v1.7539h-1.582c-1.5132,0-2.3218-.8252-2.3218-2.2871Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ItemUsage.propTypes = iconPropTypes;
}
const JobDaemon = /*#__PURE__*/React.forwardRef(function JobDaemon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12,17h8c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v11c0,1.1.9,2,2,2ZM12,4h8v11h-8V4ZM8,19h5v2h-5c-1.1,0-2-.9-2-2v-11h2v11ZM4,23h5v2h-5c-1.1,0-2-.9-2-2v-11h2v11ZM27,20c-1.6,0-3.1,1.4-4,2.4-.9-1-2.4-2.4-4-2.4-2.6,0-4,2-4,4s1.4,4,4,4,3.1-1.4,4-2.4c.9,1,2.4,2.4,4,2.4,2.6,0,4-2,4-4s-1.4-4-4-4ZM19,26c-1.5,0-2-1.1-2-2s.5-2,2-2,2,1.1,2.8,2c-.7.9-1.9,2-2.8,2ZM27,26c-.9,0-2-1.1-2.8-2,.7-.9,1.9-2,2.8-2,1.5,0,2,1.1,2,2s-.5,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JobDaemon.propTypes = iconPropTypes;
}
const JobRun = /*#__PURE__*/React.forwardRef(function JobRun({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12,17h8c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v11c0,1.1.9,2,2,2ZM12,4h8v11h-8V4ZM8,19h6v2h-6c-1.1,0-2-.9-2-2v-11h2v11ZM4,23h6v2h-6c-1.1,0-2-.9-2-2v-11h2v11ZM30,24l-6,6-1.4-1.4,3.6-3.6h-9.2v-2h9.2l-3.6-3.6,1.4-1.4,6,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JobRun.propTypes = iconPropTypes;
}
const JoinFull = /*#__PURE__*/React.forwardRef(function JoinFull({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
    "data-icon-path": "inner-path"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinFull.propTypes = iconPropTypes;
}
const JoinInner = /*#__PURE__*/React.forwardRef(function JoinInner({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinInner.propTypes = iconPropTypes;
}
const JoinLeft = /*#__PURE__*/React.forwardRef(function JoinLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
    "data-icon-path": "inner-path"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinLeft.propTypes = iconPropTypes;
}
const JoinOuter = /*#__PURE__*/React.forwardRef(function JoinOuter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinOuter.propTypes = iconPropTypes;
}
const JoinRight = /*#__PURE__*/React.forwardRef(function JoinRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
    "data-icon-path": "inner-path"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinRight.propTypes = iconPropTypes;
}
const JoinNode = /*#__PURE__*/React.forwardRef(function JoinNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 9H6V11H2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 21H6V23H2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M25 11L23.5859 12.4141 26.1719 15 18 15 18 4 12 4 12 9 8 9 8 11 12 11 12 21 8 21 8 23 12 23 12 28 18 28 18 17 26.1719 17 23.5859 19.5859 25 21 30 16 25 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JoinNode.propTypes = iconPropTypes;
}
const Jpg = /*#__PURE__*/React.forwardRef(function Jpg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H4a2,2,0,0,1-2-2V19H4v2H8V9h2V21A2,2,0,0,1,8,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Jpg.propTypes = iconPropTypes;
}
const JsError = /*#__PURE__*/React.forwardRef(function JsError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m20.3335,30h-2.667c-.9189,0-1.6665-.7476-1.6665-1.6665v-2.3335h2v2h2v-8h2v8.3335c0,.9189-.7476,1.6665-1.6665,1.6665Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m28.3335,30h-4.3335v-2h4v-2h-2c-1.103,0-2-.897-2-2v-2.3335c0-.9189.7476-1.6665,1.6665-1.6665h4.3335v2h-4v2h2c1.103,0,2,.897,2,2v2.3335c0,.9189-.7476,1.6665-1.6665,1.6665Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m16,18c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H17V16H15z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m14,26h-4.5c-.3538,0-.6809-.1868-.8608-.4912L2.1392,14.5088c-.0928-.1569-.1392-.3329-.1392-.5088s.0464-.3519.1392-.5088L8.6392,2.4912c.1799-.3044.5071-.4912.8608-.4912h13c.3538,0,.6809.1868.8608.4912l6.5,11c.0928.1569.1392.3328.1392.5088s-.0464.3519-.1392.5088l-2,3.3845-1.7217-1.0173,1.6992-2.876-5.9089-10h-11.8589l-5.9089,10,5.9089,10h3.9294v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JsError.propTypes = iconPropTypes;
}
const Json = /*#__PURE__*/React.forwardRef(function Json({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335,21h-2.667A1.6684,1.6684,0,0,1,17,19.3335v-6.667A1.6684,1.6684,0,0,1,18.6665,11h2.667A1.6684,1.6684,0,0,1,23,12.6665v6.667A1.6684,1.6684,0,0,1,21.3335,21ZM19,19h2V13H19Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335,21H9V19h4V17H11a2.002,2.002,0,0,1-2-2V12.6665A1.6684,1.6684,0,0,1,10.6665,11H15v2H11v2h2a2.002,2.002,0,0,1,2,2v2.3335A1.6684,1.6684,0,0,1,13.3335,21Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335,21H2.6665A1.6684,1.6684,0,0,1,1,19.3335V17H3v2H5V11H7v8.3335A1.6684,1.6684,0,0,1,5.3335,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Json.propTypes = iconPropTypes;
}
const JsonReference = /*#__PURE__*/React.forwardRef(function JsonReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335,6h-2.667A1.6683,1.6683,0,0,0,17,7.6665v6.667A1.6684,1.6684,0,0,0,18.6665,16h2.667A1.6683,1.6683,0,0,0,23,14.3335V7.6665A1.6683,1.6683,0,0,0,21.3335,6ZM21,14H19V8h2Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9,7.6665V10a2.002,2.002,0,0,0,2,2h2v2H9v2h4.3335A1.6683,1.6683,0,0,0,15,14.3335V12a2.002,2.002,0,0,0-2-2H11V8h4V6H10.6665A1.6683,1.6683,0,0,0,9,7.6665Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5,14H3V12H1v2.3335A1.6684,1.6684,0,0,0,2.6665,16h2.667A1.6683,1.6683,0,0,0,7,14.3335V6H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JsonReference.propTypes = iconPropTypes;
}
const JumpLink = /*#__PURE__*/React.forwardRef(function JumpLink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  JumpLink.propTypes = iconPropTypes;
}
const KeepDry = /*#__PURE__*/React.forwardRef(function KeepDry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KeepDry.propTypes = iconPropTypes;
}
const Key = /*#__PURE__*/React.forwardRef(function Key({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 9L28.0001 9 26 16 24.0001 9 22 9 25 17.9996 25 23 27 23 27 18 27.0001 18 30 9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M21 11L21 9 13 9 13 23 21 23 21 21 15 21 15 17 20 17 20 15 15 15 15 11 21 11z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11 9L8.8941 9 5 15.5527 5 9 3 9 3 23 5 23 5 18.7062 5.9277 17.2208 8.8941 23 11 23 7.1093 15.4308 11 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Key.propTypes = iconPropTypes;
}
const Keyboard = /*#__PURE__*/React.forwardRef(function Keyboard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H21V22H10z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V14H10z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H16V14H14z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20V14H18z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H8V22H6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V18H6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H12V18H10z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H16V18H14z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H26V14H22z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16H26V18H22z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16H20V18H18z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20H26V22H23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Keyboard.propTypes = iconPropTypes;
}
const KeyboardOff = /*#__PURE__*/React.forwardRef(function KeyboardOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20V14H18z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H8V22H6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V18H6z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H12V18H10z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H26V14H22z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16H26V18H22z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,10H28v13h2V10c0-1.1-0.9-2-2-2H12.2L14.2,10z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6L3.4,2L2,3.4L6.6,8H4c-1.1,0-2,0.9-2,2v14c0,1.1,0.9,2,2,2h20.6l4,4L30,28.6z M4,24V10h4.6l2,2H10v2h2.6l2,2H14v2 h2.6l2,2H10v2h10.6l2,2H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KeyboardOff.propTypes = iconPropTypes;
}
const KioskDevice = /*#__PURE__*/React.forwardRef(function KioskDevice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v13c0,1.1.9,2,2,2h7v9H4v2h24v-2h-9v-9h7ZM17,28h-2v-9h2v9ZM6,17V4h20v13H6ZM16,13c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KioskDevice.propTypes = iconPropTypes;
}
const Kubelet = /*#__PURE__*/React.forwardRef(function Kubelet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20.0444,27.2942l-3.0825-10.018-1.0132,3.04c-.1361.4084-.5183.6838-.9487.6838h-6s0-2,0-2h5.2793s1.772-5.3162,1.772-5.3162c.1307-.4123.5162-.6902.9487-.6838.4374.0046.8225.2891.9555.7058l3.0088,9.7783,1.0742-3.7589c.1227-.4293.5151-.7252.9615-.7252h5s0,2,0,2h-4.2456s-1.7933,6.2747-1.7933,6.2747c-.1216.4256-.5085.7207-.9511.7253h-.01c-.4389,0-.8265-.2863-.9556-.7058Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,28H6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v9h-2V6H6v20h10v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Kubelet.propTypes = iconPropTypes;
}
const Kubernetes = /*#__PURE__*/React.forwardRef(function Kubernetes({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["Kubernetes"]) {
      didWarnAboutDeprecation["Kubernetes"] = true;
      console.warn("The current kubernetes icon has been replaced by logo--kubernetes. As a result, the Kubernetes component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Kubernetes.propTypes = iconPropTypes;
}
const KubernetesControlPlaneNode = /*#__PURE__*/React.forwardRef(function KubernetesControlPlaneNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.951 20h-2.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157 2H8.951v2h6.1843c.4141 1.1611 1.5137 2 2.8157 2s2.4016-.8389 2.8157-2h2.1843v-2Zm-5 2c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1Zm5-10h-6.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157 2H8.951v2h2.1843c.4141 1.1611 1.5137 2 2.8157 2s2.4016-.8389 2.8157-2h6.1843v-2Zm-9 2c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8993 18.9897-2.593-11.1865a2 2 0 0 0-1.124-1.3711l-9.407-4.2544C16.5133 2.059 16.2321 2 15.9511 2s-.5623.0591-.8242.1777L5.7197 6.4321a2 2 0 0 0-1.124 1.3711l-2.593 11.1865a2.0008 2.0008 0 0 0 .3899 1.7056l6.886 8.5586A2.0001 2.0001 0 0 0 10.8367 30h10.2286a2.0001 2.0001 0 0 0 1.5581-.7461l6.886-8.5586a2.0008 2.0008 0 0 0 .3899-1.7056ZM21.0653 28H10.837l-6.886-8.5586 2.593-11.187L15.951 4l9.407 4.2549 2.593 11.1865L21.0652 28Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KubernetesControlPlaneNode.propTypes = iconPropTypes;
}
const KubernetesIpAddress = /*#__PURE__*/React.forwardRef(function KubernetesIpAddress({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m18.8157,26c-.302-.8472-.9685-1.5137-1.8157-1.8159v-2.1841h3c.2969,0,.5781-.1318.7683-.3599l5-6c.1982-.2378.2751-.5547.2078-.8569l-2-9c-.0696-.3145-.2864-.5757-.5823-.7021l-7-3c-.1257-.0542-.2598-.0811-.3938-.0811s-.2681.0269-.3938.0811l-7.0015,3c-.2959.1265-.5127.3877-.5825.7021l-1.9985,9c-.0671.3027.0098.6191.208.8569l5,6c.1902.228.4714.3599.7683.3599h3v2.1846c-.8472.3018-1.5137.9683-1.8157,1.8154H4v2h9.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h9.1843v-2h-9.1843Zm-10.7329-11.2627l1.7808-8.02,6.1365-2.6294,6.135,2.6294,1.7822,8.02-4.3855,5.2627h-7.0635l-4.3855-5.2627Zm7.9172,13.2627c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KubernetesIpAddress.propTypes = iconPropTypes;
}
const KubernetesOperator = /*#__PURE__*/React.forwardRef(function KubernetesOperator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,21h-6c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2Zm-6-8v6h6v-6h-6Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-7.7197-6.2803-14-14-14S2,8.2803,2,16s6.2803,14,14,14c2.7773,0,5.417-.7959,7.7012-2.3081.3948.1914.8315.3081,1.2988.3081,1.6543,0,3-1.3457,3-3,0-.4673-.1167-.9043-.3079-1.2988,1.5122-2.2842,2.3079-4.9238,2.3079-7.7012Zm-26,0c0-6.6167,5.3833-12,12-12s12,5.3833,12,12c0,2.248-.6152,4.3877-1.7744,6.2681-.375-.1689-.7881-.2681-1.2256-.2681-1.6543,0-3,1.3457-3,3,0,.4375.0991.8506.2681,1.2256-1.8801,1.1592-4.0198,1.7744-6.2681,1.7744-6.6167,0-12-5.3833-12-12Zm21,10c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KubernetesOperator.propTypes = iconPropTypes;
}
const KubernetesPod = /*#__PURE__*/React.forwardRef(function KubernetesPod({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5046,11.6368l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m16,31c-.1741,0-.3481-.0454-.5039-.1362l-12-7c-.3071-.1792-.4961-.5081-.4961-.8638v-14c0-.3557.189-.6846.4961-.8638L15.4961,1.1362c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l11,6.4166-1.0078,1.7275-10.4961-6.1227-11,6.4166v12.8513l11,6.4166,11-6.4166v-7.4257h2v8c0,.3557-.189.6846-.4961.8638l-12,7c-.1558.0908-.3298.1362-.5039.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KubernetesPod.propTypes = iconPropTypes;
}
const KubernetesWorkerNode = /*#__PURE__*/React.forwardRef(function KubernetesWorkerNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V10h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H9v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V24h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H23Zm-7 2c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m29.9483 18.9897-2.593-11.1865a2 2 0 0 0-1.124-1.3711l-9.407-4.2544C16.5623 2.059 16.2811 2 16.0001 2s-.5623.0591-.8242.1777L5.7687 6.4321a2 2 0 0 0-1.124 1.3711l-2.593 11.1865a2.0008 2.0008 0 0 0 .3899 1.7056l6.886 8.5586A2.0001 2.0001 0 0 0 10.8857 30h10.2286a2.0001 2.0001 0 0 0 1.5581-.7461l6.886-8.5586a2.0008 2.0008 0 0 0 .3899-1.7056ZM21.1143 28H10.886L4 19.4414l2.593-11.187L16 4l9.407 4.2549L28 19.4414 21.1142 28Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  KubernetesWorkerNode.propTypes = iconPropTypes;
}
const Label = /*#__PURE__*/React.forwardRef(function Label({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H18v2h5v2H19a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2.0023,2.0023,0,0,0,23,13Zm0,8H19V19h4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M13,9H9a2.002,2.002,0,0,0-2,2V23H9V18h4v5h2V11A2.002,2.002,0,0,0,13,9ZM9,16V11h4v5Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Label.propTypes = iconPropTypes;
}
const Language = /*#__PURE__*/React.forwardRef(function Language({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H24V21H18z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H30V17H18z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H30V13H18z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M14,21V19H9V17H7v2H2v2h8.2148a8.5914,8.5914,0,0,1-2.2159,3.9771A9.2731,9.2731,0,0,1,6.5521,23H4.3334a10.8553,10.8553,0,0,0,2.1451,3.2966A14.6584,14.6584,0,0,1,3,28.127L3.7021,30a16.42,16.42,0,0,0,4.2907-2.3362A16.4883,16.4883,0,0,0,12.2979,30L13,28.127A14.664,14.664,0,0,1,9.5228,26.3,10.3132,10.3132,0,0,0,12.2516,21Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666,13H13.333L8.75,2H6.5832L2,13H4.1664L5,11h5.3335ZM5.8331,9,7.6665,4.6,9.5,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Language.propTypes = iconPropTypes;
}
const Laptop = /*#__PURE__*/React.forwardRef(function Laptop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
    transform: "translate(0 .005)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.005H30V28.005H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Laptop.propTypes = iconPropTypes;
}
const Lasso = /*#__PURE__*/React.forwardRef(function Lasso({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Lasso.propTypes = iconPropTypes;
}
const LassoPolygon = /*#__PURE__*/React.forwardRef(function LassoPolygon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LassoPolygon.propTypes = iconPropTypes;
}
const Launch = /*#__PURE__*/React.forwardRef(function Launch({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
      d: "M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z"
    })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
      d: "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Launch.propTypes = iconPropTypes;
}
const WatsonHealthLaunchStudy_1 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22v6H6V22H26m0-2H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H20V26H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_1.propTypes = iconPropTypes;
}
const WatsonHealthLaunchStudy_2 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "7",
    r: "1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4v6H6V4H26m0-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_2.propTypes = iconPropTypes;
}
const WatsonHealthLaunchStudy_3 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22v6H6V22H26m0-2H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H20V26H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_3.propTypes = iconPropTypes;
}
const Layers = /*#__PURE__*/React.forwardRef(function Layers({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,21.12,16,27.8643,28.5259,21.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,30Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a.9967.9967,0,0,1-.4741-.12l-13-7a1,1,0,0,1,0-1.7607l13-7a.9982.9982,0,0,1,.9482,0l13,7a1,1,0,0,1,0,1.7607l-13,7A.9967.9967,0,0,1,16,18ZM5.1094,10,16,15.8643,26.8906,10,16,4.1358Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Layers.propTypes = iconPropTypes;
}
const LayersExternal = /*#__PURE__*/React.forwardRef(function LayersExternal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,24c-.1631,0-.3262-.0398-.4741-.1196l-13-7,.9482-1.7607,12.5259,6.7446,12.5259-6.7446.9482,1.7607-13,7c-.1479.0798-.311.1196-.4741.1196Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c-.1631,0-.3262-.0398-.4741-.1196l-13-7,.9482-1.7607,12.5259,6.7446,12.5259-6.7446.9482,1.7607-13,7c-.1479.0798-.311.1196-.4741.1196Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.4741,9.1196L16,1.8643v2.2715l10.8906,5.8643-10.8906,5.8643v2.2715l13.4741-7.2554c.324-.1743.5259-.5122.5259-.8804s-.2019-.7061-.5259-.8804Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.4141,9.4141l3.5859-3.586v8.1719s2,0,2,0V5.8281s3.5859,3.5859,3.5859,3.5859l1.4141-1.414L9,2,3,8l1.4141,1.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LayersExternal.propTypes = iconPropTypes;
}
const Legend = /*#__PURE__*/React.forwardRef(function Legend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    x: "4",
    y: "20",
    rx: "1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12h-5a.5.5,0,0,1-.4473-.7236l2.5-5.0224a.5206.5206,0,0,1,.8945,0l2.5,5.0225A.5.5,0,0,1,9.5,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Legend.propTypes = iconPropTypes;
}
const LetterAa = /*#__PURE__*/React.forwardRef(function LetterAa({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H18v2h5v2H19a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2,2,0,0,0,23,13Zm0,8H19V19h4Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13,9H9a2,2,0,0,0-2,2V23H9V18h4v5h2V11A2,2,0,0,0,13,9ZM9,16V11h4v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterAa.propTypes = iconPropTypes;
}
const LetterBb = /*#__PURE__*/React.forwardRef(function LetterBb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H19V9H17V23h6a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M15,12a3,3,0,0,0-3-3H7V23h5a3,3,0,0,0,3-3V18a3,3,0,0,0-.78-2A3,3,0,0,0,15,14ZM9,11h3a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H9Zm4,9a1,1,0,0,1-1,1H9V17h3a1,1,0,0,1,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterBb.propTypes = iconPropTypes;
}
const LetterCc = /*#__PURE__*/React.forwardRef(function LetterCc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M24,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v6h5Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterCc.propTypes = iconPropTypes;
}
const LetterDd = /*#__PURE__*/React.forwardRef(function LetterDd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9v4H19a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6V9Zm-4,6h4v6H19Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23H7V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,11,23ZM9,21h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterDd.propTypes = iconPropTypes;
}
const LetterEe = /*#__PURE__*/React.forwardRef(function LetterEe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25,19V15a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V21H19V19Zm-6-4h4v2H19Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterEe.propTypes = iconPropTypes;
}
const LetterFf = /*#__PURE__*/React.forwardRef(function LetterFf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24,11V9H21a2,2,0,0,0-2,2v2H17v2h2v8h2V15h3V13H21V11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterFf.propTypes = iconPropTypes;
}
const LetterGg = /*#__PURE__*/React.forwardRef(function LetterGg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v2H18v2h5a2,2,0,0,0,2-2V13Zm4,8H19V15h4Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h4V17H11V15h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterGg.propTypes = iconPropTypes;
}
const LetterHh = /*#__PURE__*/React.forwardRef(function LetterHh({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H19V9H17V23h2V15h4v8h2V15A2,2,0,0,0,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterHh.propTypes = iconPropTypes;
}
const LetterIi = /*#__PURE__*/React.forwardRef(function LetterIi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13H22V23H20z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H22V11H20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterIi.propTypes = iconPropTypes;
}
const LetterJj = /*#__PURE__*/React.forwardRef(function LetterJj({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H22V11H20z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25H17v2h3a2,2,0,0,0,2-2V13H20Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H10a2,2,0,0,1-2-2V19h2v2h4V9h2V21A2,2,0,0,1,14,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterJj.propTypes = iconPropTypes;
}
const LetterKk = /*#__PURE__*/React.forwardRef(function LetterKk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterKk.propTypes = iconPropTypes;
}
const LetterLl = /*#__PURE__*/React.forwardRef(function LetterLl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21L11 9 9 9 9 23 17 23 17 21 11 21z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H21a2,2,0,0,1-2-2V9h2V21h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterLl.propTypes = iconPropTypes;
}
const LetterMm = /*#__PURE__*/React.forwardRef(function LetterMm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H16V23h2V15h2v8h2V15h2v8h2V15A2,2,0,0,0,24,13Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterMm.propTypes = iconPropTypes;
}
const LetterNn = /*#__PURE__*/React.forwardRef(function LetterNn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V15H19v8H17V13h6a2,2,0,0,1,2,2Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterNn.propTypes = iconPropTypes;
}
const LetterOo = /*#__PURE__*/React.forwardRef(function LetterOo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v6A2,2,0,0,1,23,23Zm-4-8v6h4V15Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h4a2,2,0,0,1,2,2V21A2,2,0,0,1,13,23ZM9,11V21h4V11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterOo.propTypes = iconPropTypes;
}
const LetterPp = /*#__PURE__*/React.forwardRef(function LetterPp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H17V27h2V23h4a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M9,23H7V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H9Zm0-7h4V11H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterPp.propTypes = iconPropTypes;
}
const LetterQq = /*#__PURE__*/React.forwardRef(function LetterQq({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v4h2V13Zm4,8H19V15h4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M13,9H9a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h1v2a2,2,0,0,0,2,2h2V25H12V23h1a2,2,0,0,0,2-2V11A2,2,0,0,0,13,9ZM9,21V11h4V21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterQq.propTypes = iconPropTypes;
}
const LetterRr = /*#__PURE__*/React.forwardRef(function LetterRr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M16,15V11a2,2,0,0,0-2-2H8V23h2V17h1.48l2.34,6H16l-2.33-6H14A2,2,0,0,0,16,15Zm-6-4h4v4H10Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterRr.propTypes = iconPropTypes;
}
const LetterSs = /*#__PURE__*/React.forwardRef(function LetterSs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M22,23H17V21h5V19H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v2h3a2,2,0,0,1,2,2v2A2,2,0,0,1,22,23Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H7V21h6V17H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,13,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterSs.propTypes = iconPropTypes;
}
const LetterTt = /*#__PURE__*/React.forwardRef(function LetterTt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M23,15V13H20V11H18v2H16v2h2v6a2,2,0,0,0,2,2h3V21H20V15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterTt.propTypes = iconPropTypes;
}
const LetterUu = /*#__PURE__*/React.forwardRef(function LetterUu({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H19a2,2,0,0,1-2-2V13h2v8h4V13h2v8A2,2,0,0,1,23,23Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterUu.propTypes = iconPropTypes;
}
const LetterVv = /*#__PURE__*/React.forwardRef(function LetterVv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterVv.propTypes = iconPropTypes;
}
const LetterWw = /*#__PURE__*/React.forwardRef(function LetterWw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterWw.propTypes = iconPropTypes;
}
const LetterXx = /*#__PURE__*/React.forwardRef(function LetterXx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterXx.propTypes = iconPropTypes;
}
const LetterYy = /*#__PURE__*/React.forwardRef(function LetterYy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13l-2,7.52L19.08,13H17l3.15,9.87L19.53,25H17v2h2.26a2,2,0,0,0,1.91-1.42L25,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterYy.propTypes = iconPropTypes;
}
const LetterZz = /*#__PURE__*/React.forwardRef(function LetterZz({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LetterZz.propTypes = iconPropTypes;
}
const License = /*#__PURE__*/React.forwardRef(function License({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H22V8H10z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H22V12H10z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H16V26H10z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H16V16H10z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  License.propTypes = iconPropTypes;
}
const LicenseDraft = /*#__PURE__*/React.forwardRef(function LicenseDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H12V26H8z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseDraft.propTypes = iconPropTypes;
}
const LicenseGlobal = /*#__PURE__*/React.forwardRef(function LicenseGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,22,14Zm5.91,7H25.9563a12.03,12.03,0,0,0-1.2183-4.3325A6.01,6.01,0,0,1,27.91,21Zm-7.8545,0A10.0135,10.0135,0,0,1,22,16.0146,10.0121,10.0121,0,0,1,23.9448,21Zm3.89,2A10.01,10.01,0,0,1,22,27.9854,10.0121,10.0121,0,0,1,20.0552,23Zm-4.6831-6.332A12.0265,12.0265,0,0,0,18.0435,21H16.09A6.01,6.01,0,0,1,19.2617,16.668ZM16.09,23h1.9532a12.0265,12.0265,0,0,0,1.2182,4.332A6.01,6.01,0,0,1,16.09,23Zm8.6482,4.332A12.0242,12.0242,0,0,0,25.9565,23H27.91A6.0088,6.0088,0,0,1,24.7385,27.332Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H12V16H6z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H18V8H6z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H18V12H6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H12V26H6z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseGlobal.propTypes = iconPropTypes;
}
const LicenseMaintenance = /*#__PURE__*/React.forwardRef(function LicenseMaintenance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseMaintenance.propTypes = iconPropTypes;
}
const LicenseMaintenanceDraft = /*#__PURE__*/React.forwardRef(function LicenseMaintenanceDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13V11H17.8579a3.94,3.94,0,0,0-.4248-1.019L18.95,8.4644,17.5356,7.05,16.019,8.5669A3.9443,3.9443,0,0,0,15,8.1421V6H13V8.1421a3.9443,3.9443,0,0,0-1.019.4248L10.4644,7.05,9.05,8.4644,10.5669,9.981A3.94,3.94,0,0,0,10.1421,11H8v2h2.1421a3.94,3.94,0,0,0,.4248,1.019L9.05,15.5356,10.4644,16.95l1.5166-1.5166A3.9443,3.9443,0,0,0,13,15.8579V18h2V15.8579a3.9443,3.9443,0,0,0,1.019-.4248L17.5356,16.95,18.95,15.5356,17.4331,14.019A3.94,3.94,0,0,0,17.8579,13Zm-6,1a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,14,14Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseMaintenanceDraft.propTypes = iconPropTypes;
}
const LicenseThirdParty = /*#__PURE__*/React.forwardRef(function LicenseThirdParty({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24a4,4,0,1,0-4-4A4,4,0,0,0,24,24Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,24,18Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseThirdParty.propTypes = iconPropTypes;
}
const LicenseThirdPartyDraft = /*#__PURE__*/React.forwardRef(function LicenseThirdPartyDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M17,15H11a3,3,0,0,0-3,3v1h2V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1h2V18A3,3,0,0,0,17,15Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14a4,4,0,1,0-4-4A4,4,0,0,0,14,14Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,14,8Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LicenseThirdPartyDraft.propTypes = iconPropTypes;
}
const Lifesaver = /*#__PURE__*/React.forwardRef(function Lifesaver({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Lifesaver.propTypes = iconPropTypes;
}
const Light = /*#__PURE__*/React.forwardRef(function Light({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V3.5H7.5z"
    })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
      d: "M10.8 3.4H13.3V4.4H10.8z",
      transform: "rotate(-45.001 12.041 3.923)"
    })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
      d: "M12.5 7.5H15V8.5H12.5z"
    })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
      d: "M11.6 10.8H12.6V13.3H11.6z",
      transform: "rotate(-45.001 12.075 12.041)"
    })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 12.5H8.5V15H7.5z"
    })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
      d: "M2.7 11.6H5.2V12.6H2.7z",
      transform: "rotate(-45.001 3.96 12.079)"
    })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
      d: "M1 7.5H3.5V8.5H1z"
    })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
      d: "M3.4 2.7H4.4V5.2H3.4z",
      transform: "rotate(-45.001 3.925 3.961)"
    })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
      d: "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H17V30H15z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Light.propTypes = iconPropTypes;
}
const LightFilled = /*#__PURE__*/React.forwardRef(function LightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H17V30H15z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LightFilled.propTypes = iconPropTypes;
}
const Lightning = /*#__PURE__*/React.forwardRef(function Lightning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Lightning.propTypes = iconPropTypes;
}
const Link = /*#__PURE__*/React.forwardRef(function Link({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Link.propTypes = iconPropTypes;
}
const Linux = /*#__PURE__*/React.forwardRef(function Linux({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Linux.propTypes = iconPropTypes;
}
const LinuxAlt = /*#__PURE__*/React.forwardRef(function LinuxAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LinuxAlt.propTypes = iconPropTypes;
}
const LinuxNamespace = /*#__PURE__*/React.forwardRef(function LinuxNamespace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M26 2H28V30H26z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,25H6c-1.1046,0-2-.8954-2-2v-14c0-1.1046.8954-2,2-2h14c1.1046,0,2,.8954,2,2v14c0,1.1046-.8954,2-2,2Zm0-16H6v14h14v-14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LinuxNamespace.propTypes = iconPropTypes;
}
const List = /*#__PURE__*/React.forwardRef(function List({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H28V26H10z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H28V17H10z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H6V17H4z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V8H4z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H6V26H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  List.propTypes = iconPropTypes;
}
const ListBoxes = /*#__PURE__*/React.forwardRef(function ListBoxes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,14ZM4,6v6h6.0012L10,6Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,28ZM4,20v6h6.0012L10,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListBoxes.propTypes = iconPropTypes;
}
const ListBulleted = /*#__PURE__*/React.forwardRef(function ListBulleted({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
      cx: "3.5",
      cy: "4.5",
      r: "1.5"
    })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
      cx: "3.5",
      cy: "11.5",
      r: "1.5"
    })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
      d: "M8 11H15V12H8z"
    })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
      d: "M8 4H15V5H8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "9",
    r: "3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListBulleted.propTypes = iconPropTypes;
}
const ListChecked = /*#__PURE__*/React.forwardRef(function ListChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListChecked.propTypes = iconPropTypes;
}
const ListCheckedMirror = /*#__PURE__*/React.forwardRef(function ListCheckedMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H16V24H2z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H16V10H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListCheckedMirror.propTypes = iconPropTypes;
}
const ListDropdown = /*#__PURE__*/React.forwardRef(function ListDropdown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V13H15z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H26V13H19z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H17V19H15z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H26V19H19z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H26V25H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListDropdown.propTypes = iconPropTypes;
}
const ListNumbered = /*#__PURE__*/React.forwardRef(function ListNumbered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4V24a2,2,0,0,1,2-2H8V20H4V18H8a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H6v2h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListNumbered.propTypes = iconPropTypes;
}
const ListNumberedMirror = /*#__PURE__*/React.forwardRef(function ListNumberedMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28h-6v-4c0-1.1,0.9-2,2-2h2v-2h-4v-2h4c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2v2h4V28z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H16V24H2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H16V10H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ListNumberedMirror.propTypes = iconPropTypes;
}
const LoadBalancerApplication = /*#__PURE__*/React.forwardRef(function LoadBalancerApplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V14H15v2H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2V12H23V2Zm2,2h2v6H11Zm10,6H15V4h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerApplication.propTypes = iconPropTypes;
}
const LoadBalancerClassic = /*#__PURE__*/React.forwardRef(function LoadBalancerClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10V2H12v8ZM14,8V4h4V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerClassic.propTypes = iconPropTypes;
}
const LoadBalancerGlobal = /*#__PURE__*/React.forwardRef(function LoadBalancerGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerGlobal.propTypes = iconPropTypes;
}
const LoadBalancerListener = /*#__PURE__*/React.forwardRef(function LoadBalancerListener({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V10H15z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H21V10H19z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13V10H11z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V13H15v3H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H21V5H11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerListener.propTypes = iconPropTypes;
}
const LoadBalancerLocal = /*#__PURE__*/React.forwardRef(function LoadBalancerLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V10H15v6H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H21V7H11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerLocal.propTypes = iconPropTypes;
}
const LoadBalancerNetwork = /*#__PURE__*/React.forwardRef(function LoadBalancerNetwork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v4H7V18h8v4h2V18h8v4h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10V2H12v8h8ZM14,8V4h4V8Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24a2.9948,2.9948,0,0,0-2.8157,2H18.8157a2.982,2.982,0,0,0-5.6314,0H8.8157a3,3,0,1,0,0,2h4.3686a2.982,2.982,0,0,0,5.6314,0h4.3686A2.9947,2.9947,0,1,0,26,24ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerNetwork.propTypes = iconPropTypes;
}
const LoadBalancerPool = /*#__PURE__*/React.forwardRef(function LoadBalancerPool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H22V17H10z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,6.2852A2.9665,2.9665,0,0,0,9,5,3,3,0,1,0,6,8a2.96,2.96,0,0,0,1.2852-.3008L10,10.4141V13h2V9.5859ZM6,6A1,1,0,1,1,7,5,1.0009,1.0009,0,0,1,6,6Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5a3,3,0,1,0-4,2.8154V13h2V7.8159A2.9957,2.9957,0,0,0,19,5ZM16,6a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,6Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.0033,3.0033,0,0,0-3,3,2.9665,2.9665,0,0,0,.3,1.2852L20,9.5859V13h2V10.4141l2.7148-2.7149A2.96,2.96,0,0,0,26,8a3,3,0,0,0,0-6Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,6Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M12,19H10v2.5859L7.2854,24.3008A2.9609,2.9609,0,0,0,6,24a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L12,22.4141ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24.1841V19H15v5.1841a3,3,0,1,0,2,0ZM16,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24a2.9609,2.9609,0,0,0-1.2854.3008L22,21.5859V19H20v3.4141l3.3,3.3007A2.9665,2.9665,0,0,0,23,27a3,3,0,1,0,3-3Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerPool.propTypes = iconPropTypes;
}
const LoadBalancerVpc = /*#__PURE__*/React.forwardRef(function LoadBalancerVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H2V24H8ZM4,28H6V26H4Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M19,30H13V24h6Zm-4-2h2V26H15Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H24V24h6Zm-4-2h2V26H26Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,4Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H21a4.0045,4.0045,0,0,1-4-4H15a4.0045,4.0045,0,0,1-4,4H6a2.0023,2.0023,0,0,0-2,2v4H6V18h5A5.9694,5.9694,0,0,0,15,16.46V22h2V16.46A5.9694,5.9694,0,0,0,21,18h5v4h2V18A2.0023,2.0023,0,0,0,26,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoadBalancerVpc.propTypes = iconPropTypes;
}
const Location = /*#__PURE__*/React.forwardRef(function Location({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Location.propTypes = iconPropTypes;
}
const LocationCompany = /*#__PURE__*/React.forwardRef(function LocationCompany({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H17V18H15z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V14H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationCompany.propTypes = iconPropTypes;
}
const LocationCompanyFilled = /*#__PURE__*/React.forwardRef(function LocationCompanyFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationCompanyFilled.propTypes = iconPropTypes;
}
const LocationCurrent = /*#__PURE__*/React.forwardRef(function LocationCurrent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationCurrent.propTypes = iconPropTypes;
}
const LocationFilled = /*#__PURE__*/React.forwardRef(function LocationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "4",
    fill: "none"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationFilled.propTypes = iconPropTypes;
}
const LocationHazard = /*#__PURE__*/React.forwardRef(function LocationHazard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H17V16H15z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationHazard.propTypes = iconPropTypes;
}
const LocationHazardFilled = /*#__PURE__*/React.forwardRef(function LocationHazardFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationHazardFilled.propTypes = iconPropTypes;
}
const LocationHeart = /*#__PURE__*/React.forwardRef(function LocationHeart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationHeart.propTypes = iconPropTypes;
}
const LocationHeartFilled = /*#__PURE__*/React.forwardRef(function LocationHeartFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationHeartFilled.propTypes = iconPropTypes;
}
const LocationInfo = /*#__PURE__*/React.forwardRef(function LocationInfo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17 18L17 11 13 11 13 13 15 13 15 18 12 18 12 20 20 20 20 18 17 18z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15.5,6c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30l-8.4355-9.9487c-.0479-.0571-.3481-.4516-.3481-.4516-1.4507-1.9268-2.2163-4.2065-2.2163-6.5998,0-6.0641,4.9346-11,11-11s11,4.9359,11,11c0,2.3933-.7656,4.673-2.2148,6.5973l-.0015.0024s-.3003.3944-.3447.4474l-8.439,9.9528Zm-7.1875-11.605c.001.0007.2334.3083.2866.3744l6.9009,8.1385,6.9102-8.1498c.0439-.0552.2783-.3649.2788-.3656,1.1851-1.5746,1.811-3.4376,1.811-5.3925,0-4.9615-4.0376-9-9-9S7,8.0385,7,13c0,1.9559.627,3.8199,1.8125,5.395h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationInfo.propTypes = iconPropTypes;
}
const LocationInfoFilled = /*#__PURE__*/React.forwardRef(function LocationInfoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-6.0654,0-11,4.936-11,11,0,2.3931.7656,4.6729,2.2163,6.5996,0,0,.3003.3945.3481.4517l8.4355,9.9487,8.439-9.9526c.0444-.0532.3447-.4478.3447-.4478l.0015-.0024c1.4492-1.9243,2.2148-4.2041,2.2148-6.5972,0-6.064-4.9346-11-11-11Zm-.5,4c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "0",
    d: "m15.5,6c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationInfoFilled.propTypes = iconPropTypes;
}
const LocationPerson = /*#__PURE__*/React.forwardRef(function LocationPerson({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,14Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,16,10Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationPerson.propTypes = iconPropTypes;
}
const LocationPersonFilled = /*#__PURE__*/React.forwardRef(function LocationPersonFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationPersonFilled.propTypes = iconPropTypes;
}
const LocationSave = /*#__PURE__*/React.forwardRef(function LocationSave({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30h2V28a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V28a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,18Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.001,1.001,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6016-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0269,7.5678L4.6719,4.6715l17.5244,6.3726Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationSave.propTypes = iconPropTypes;
}
const LocationStar = /*#__PURE__*/React.forwardRef(function LocationStar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationStar.propTypes = iconPropTypes;
}
const LocationStarFilled = /*#__PURE__*/React.forwardRef(function LocationStarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LocationStarFilled.propTypes = iconPropTypes;
}
const Locked = /*#__PURE__*/React.forwardRef(function Locked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Locked.propTypes = iconPropTypes;
}
const LockedAndBlocked = /*#__PURE__*/React.forwardRef(function LockedAndBlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4461,20.1005c-.1386-.0692-.2914-.1052-.4464-.1053h-10c-.5522,0-1.0001.4474-1.0002.9998,0,.1338.0268.2662.0789.3895l5.0268,10.0581c.1694.3388.5158.5527.8946.5527.3788,0,.7253-.2139.8947-.5527l5-10c.2468-.4944.046-1.0953-.4484-1.342h0ZM8,16h16v2h2v-2c0-1.1046-.8954-2-2-2h-2v-6c0-3.3137-2.6863-6-6-6s-6,2.6863-6,6v6h-2c-1.1046,0-2,.8954-2,2v12c0,1.1046.8954,2,2,2h11v-2h-11v-12ZM12,8c0-2.2092,1.7908-4,4-4s4,1.7908,4,4v6h-8v-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LockedAndBlocked.propTypes = iconPropTypes;
}
const LogicalPartition = /*#__PURE__*/React.forwardRef(function LogicalPartition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogicalPartition.propTypes = iconPropTypes;
}
const Login = /*#__PURE__*/React.forwardRef(function Login({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Login.propTypes = iconPropTypes;
}
const LogoAngular = /*#__PURE__*/React.forwardRef(function LogoAngular({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16h4.9L16,10.8L13.5,16z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoAngular.propTypes = iconPropTypes;
}
const LogoAnsibleCommunity = /*#__PURE__*/React.forwardRef(function LogoAnsibleCommunity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6 c1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoAnsibleCommunity.propTypes = iconPropTypes;
}
const LogoDigg = /*#__PURE__*/React.forwardRef(function LogoDigg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48,7.6v3.92H2V21H9.28V7.6Zm0,11.2H4.8v-5H6.48Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 11.52H13.2V21.04H10.4z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 7.6H13.2V10.399999999999999H10.4z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M14.32,11.52V21H18.8v1.12H14.32V24.4H21.6V11.52ZM18.8,18.8H17.12v-5H18.8Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M22.72,11.52V21H27.2v1.12H22.72V24.4H30V11.52ZM27.2,18.8H25.52v-5H27.2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoDigg.propTypes = iconPropTypes;
}
const LogoDiscord = /*#__PURE__*/React.forwardRef(function LogoDiscord({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5 c0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5 c0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3 c0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1 c0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1 C25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C23.2,18.6,22.1,19.9,20.7,19.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoDiscord.propTypes = iconPropTypes;
}

export { IotPlatform, Ip, Iso, IsoFilled, IsoOutline, ItemDefinition, ItemUsage, JobDaemon, JobRun, JoinFull, JoinInner, JoinLeft, JoinNode, JoinOuter, JoinRight, Jpg, JsError, Json, JsonReference, JumpLink, KeepDry, Key, Keyboard, KeyboardOff, KioskDevice, Kubelet, Kubernetes, KubernetesControlPlaneNode, KubernetesIpAddress, KubernetesOperator, KubernetesPod, KubernetesWorkerNode, Label, Language, Laptop, Lasso, LassoPolygon, Launch, Layers, LayersExternal, Legend, LetterAa, LetterBb, LetterCc, LetterDd, LetterEe, LetterFf, LetterGg, LetterHh, LetterIi, LetterJj, LetterKk, LetterLl, LetterMm, LetterNn, LetterOo, LetterPp, LetterQq, LetterRr, LetterSs, LetterTt, LetterUu, LetterVv, LetterWw, LetterXx, LetterYy, LetterZz, License, LicenseDraft, LicenseGlobal, LicenseMaintenance, LicenseMaintenanceDraft, LicenseThirdParty, LicenseThirdPartyDraft, Lifesaver, Light, LightFilled, Lightning, Link, Linux, LinuxAlt, LinuxNamespace, List, ListBoxes, ListBulleted, ListChecked, ListCheckedMirror, ListDropdown, ListNumbered, ListNumberedMirror, LoadBalancerApplication, LoadBalancerClassic, LoadBalancerGlobal, LoadBalancerListener, LoadBalancerLocal, LoadBalancerNetwork, LoadBalancerPool, LoadBalancerVpc, Location, LocationCompany, LocationCompanyFilled, LocationCurrent, LocationFilled, LocationHazard, LocationHazardFilled, LocationHeart, LocationHeartFilled, LocationInfo, LocationInfoFilled, LocationPerson, LocationPersonFilled, LocationSave, LocationStar, LocationStarFilled, Locked, LockedAndBlocked, LogicalPartition, Login, LogoAngular, LogoAnsibleCommunity, LogoDigg, LogoDiscord, WatsonHealthLaunchStudy_1, WatsonHealthLaunchStudy_2, WatsonHealthLaunchStudy_3 };
